<template>
	<div>
		<!-- Banner Image -->
		<img
			class="banner-image"
			src="../assets/images/bts-membership-banner.jpg"
		/>
		<section class="section">
			<div class="columns">
				<div class="column" v-if="fullName">
					<b-message
						title="Thankyou!"
						type="is-success"
						aria-close-label="Close message"
					>
						Thankyou {{ fullName }}, your application has been received and we
						will be in touch shortly.
					</b-message>
				</div>
				<div class="column" v-else>
					<b-message
						title="Error!"
						type="is-danger"
						aria-close-label="Close message"
					>
						Something seems to have gone wrong, please try again.
					</b-message>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Confirmation',

	components: {},

	data() {
		return {
			fullName: null,
		};
	},

	created() {
		this.checkName(this.$route.query.name);
	},

	methods: {
		checkName(name) {
			if (name !== undefined) {
				this.fullName = this.$route.query.name;
			}
		},
	},
};
</script>

<style></style>
